import React from 'react'

import { BottomSheet, SH1, Stack, XStack, colors } from '@zet/design-system'
import DateRangePicker from '@zet/design-system/dateRangePicker'
import Pressable from '@zet/design-system/pressable'
import CalenderOutlined from '@zet/design-system/svg/CalenderOutlined'
import Close from '@zet/design-system/svg/Close'
import { i18n } from '@zet/localization'
import ArrowRight from '@zet/svg/ArrowRight'

import HandleButton from '../earningsFilterTabs/handleButton'

const DateOptions = ({
  timeFilterOptions,
  filterIndex,
  isBSheetVisible,
  handleCloseBsheet,
  handleDateFilter,
  handleOpenDatePicker,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  isModalVisible,
  setIsModalVisible,
  handleApply,
  handleReset,
}) => {
  const today = new Date()
  return (
    <BottomSheet
      visible={isBSheetVisible}
      onDismiss={handleCloseBsheet}
      sheetName="earnings_subsection_filters"
    >
      <Stack className="pb-3">
        <XStack className="border-grays-30 mb-3 items-center justify-between border-b px-3 py-2">
          <XStack className="items-center">
            <CalenderOutlined className="mr-2 mt-1" />
            <SH1>{i18n.t('timeRange')}</SH1>
          </XStack>
          <Pressable onPress={handleCloseBsheet}>
            <Close className="mt-1" />
          </Pressable>
        </XStack>
        {timeFilterOptions.map((filter, index) => (
          <Pressable
            className="bg-grays-30 border-grays-30 mx-3 mb-2 rounded border p-3"
            style={{
              backgroundColor: filterIndex === index ? '#CFE3FF' : '#F5F7FB',
            }}
            onPress={() => handleDateFilter(filter, index)}
            key={index}
          >
            <SH1
              style={{
                color:
                  filterIndex === index ? colors.grays[80] : colors.grays[60],
              }}
            >
              {filter.name}
            </SH1>
          </Pressable>
        ))}
        <Pressable
          className="border-grays-30 mx-3 mb-2 flex-row items-center justify-between rounded border bg-[#F5F7FB] p-3"
          onPress={handleOpenDatePicker}
          style={{
            backgroundColor: filterIndex === 4 ? '#CFE3FF' : '#F5F7FB',
          }}
        >
          <SH1 className="text-grays-60">{i18n.t('selectDate')}</SH1>
          <ArrowRight />
        </Pressable>
        <DateRangePicker
          setIsModalVisible={setIsModalVisible}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          startDate={startDate}
          endDate={endDate}
          today={today}
          isModalVisible={isModalVisible}
        />

        <HandleButton
          disableApply={!(endDate && startDate)}
          handleApply={handleApply}
          handleReset={handleReset}
        />
      </Stack>
    </BottomSheet>
  )
}

export default DateOptions
